import { Component } from '@angular/core';

@Component({
  standalone: true,
  selector: 'aw-stub',
  template: '',
})
export class StubComponent {}
